module.exports = __webpack_public_path__ + "img/mp_qrcode.4148f42f.jpg";